module.exports = __webpack_public_path__ + "img/art.80f22f0c.png";